import React from 'react'
import classes from './../Onboarding.module.scss';

const UpperDiv = ({children , className ,style}) => {
  return (
    <div className={classes.UpperDiv} style={style}>
        {children}
    </div>
  )
}

export default UpperDiv